import { render, staticRenderFns } from "./zwxxlb.vue?vue&type=template&id=bd73e2ce&scoped=true"
import script from "./zwxxlb.vue?vue&type=script&lang=js"
export * from "./zwxxlb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd73e2ce",
  null
  
)

export default component.exports